import {
  getFontWeight,
  getTextColor,
  getTextEllipsis,
  getTextStyle,
} from "cms/theme/helpers";
import {
  TextAlign,
  TextTransform,
  TextVariant,
  TextWeight,
} from "cms/theme/theme";
import Styled from "styled-components";

export interface TextContainerProps {
  $variant: TextVariant;
  $weight?: TextWeight;
  $textAlign?: TextAlign;
  $textTransform?: TextTransform;
  $color?: string;
  $ellipsis?: boolean;
  $marginTop?: React.CSSProperties["marginTop"];
  $marginBottom?: React.CSSProperties["marginBottom"];
  $marginLeft?: React.CSSProperties["marginLeft"];
  $marginRight?: React.CSSProperties["marginRight"];
}

export const TextContainer = Styled.div<TextContainerProps>`
  ${(props) => getTextStyle(props.theme, props.$variant)}
  color: ${(props) => getTextColor(props.theme, props.$color)};
  text-align: ${(props) => (props.$textAlign ? props.$textAlign : "inherit")};
  font-weight: ${(props) =>
    getFontWeight(props.theme, props.$variant, props.$weight)};
  margin-top: ${(props) => props.$marginTop || "0"};
  margin-bottom: ${(props) => props.$marginBottom || "0"};
  margin-left: ${(props) => props.$marginLeft || "0"};
  margin-right: ${(props) => props.$marginRight || "0"};
  white-space: pre-line;

  ${(props) => (props.$ellipsis ? getTextEllipsis() : "")}
`;
